import MenuService from "./menuService";

$(() => {
    initializeLeftMenu()
});

function initializeLeftMenu() {
    $("[data-left-menu]").each(function () {
        new LeftMenu(this);
    });
}

class LeftMenu {
    currentPageId: number;
    classes = [
        {
            item: "left-navigation-first-level-item",
            linkWrapper: "left-navigation-first-level-item-link-wrapper",
            link: "left-navigation-first-level-item-link"
        },
        {
            item: "left-navigation-second-level-item",
            linkWrapper: "left-navigation-second-level-item-link-wrapper",
            link: "left-navigation-second-level-item-link"
        },
        {
            item: "left-navigation-third-level-item",
            linkWrapper: "left-navigation-third-level-item-link-wrapper",
            link: "left-navigation-third-level-item-link"
        },
        {
            item: "left-navigation-fourth-level-item",
            linkWrapper: "left-navigation-fourth-level-item-link-wrapper",
            link: "left-navigation-fourth-level-item-link"
        },
        {
            item: "left-navigation-fifth-level-item",
            linkWrapper: "left-navigation-fifth-level-item-link-wrapper",
            link: "left-navigation-fifth-level-item-link"
        }
    ]
    MAXIMUM_DEEPNESS_ALLOWED = 4;// maximum deepness + 1 is "left-navigation-fifth", there is no left-navigation-sixth


    constructor(leftMenu: HTMLElement) {
        this.currentPageId = parseInt(leftMenu.dataset.currentPageId);

        const nodes = [];
        $(leftMenu).find("[data-left-menu-item-level-2]").each(function () {
            nodes.push({ el: this, isSuccessful: false, isLoading: false });
        });

        this.loadGrandChildren(nodes);
    }

    /**
     * Will iterate over loadedChildren and try to load grand children if possible
     */
    async loadGrandChildren(loadedChildren: { isLoading: boolean, isSuccessful: boolean, el: HTMLElement }[], deepness = 1) {
        const elements = Object.values(loadedChildren).filter(c => !c.isLoading && !c.isSuccessful);

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            this.loadSpecificGrandChildren(element, deepness);
        }
    }

    async loadSpecificGrandChildren(children: { isLoading: boolean, isSuccessful: boolean, el: HTMLElement }, deepness = 1) {
        const self = this;
        const element = children.el;
        const contentId = parseInt(element.dataset.contentId);
        const jqueryElement = $(element);

        try {
            children.isLoading = true;

            const node = await MenuService.getNavigationNode(contentId, this.currentPageId);

            const subChildren: { isLoading: boolean, isSuccessful: boolean, el: HTMLElement }[] = [];

            if (deepness < self.MAXIMUM_DEEPNESS_ALLOWED && node.children.length && node.childrenLoaded) {

                const collapseName = `collapse-${contentId}`;

                const childrenContainerElement = $(`
                    <ul class="no-bullet collapse" id="${collapseName}"></ul>
                `);

                node.children.forEach((node) => {
                    const nodeClasses = this.classes[deepness + 1];
                    if (nodeClasses.item == "left-navigation-fourth-level-item" && node.active)
                    {
                        let elements = document.querySelectorAll(".left-navigation-third-level-item");
                        // loop through all the elements
                        elements.forEach(element => {
                            element.className = "left-navigation-third-level-item";
                        });
                    }
                    const subChildNode = $(`
                        <li class="${nodeClasses.item}${node.active ? " active" : ""}" data-content-id="${node.contentId}">
                            <div class="${nodeClasses.linkWrapper}">
                                <a href="${node.friendlyUrl}" class="${nodeClasses.link}">${node.name}</a>
                            </div>
                        </li>
                    `);
                    childrenContainerElement.append(subChildNode);
                    subChildren.push({
                        el: subChildNode.get()[0],
                        isSuccessful: false,
                        isLoading: false
                    })
                })


                jqueryElement.append(childrenContainerElement);

                const toggleElement = $(`<span data-toggle="collapse" class="icon2019 icon-chevron-right collapsed" data-target="${collapseName}" aria-expanded="false"></span>`);
                toggleElement.on("click", function () {
                    /* Manually set the toggle state by changing the activator's class */
                    if (toggleElement.attr("aria-expanded") === true.toString()) {
                        childrenContainerElement.collapse("hide");
                        toggleElement.attr("aria-expanded", false.toString());
                        toggleElement.addClass("collapsed");
                    } else {
                        childrenContainerElement.collapse("show");
                        toggleElement.attr("aria-expanded", true.toString());
                        toggleElement.removeClass("collapsed");
                        self.loadGrandChildren(subChildren, deepness + 1);// On show, load all children
                    }
                });

                jqueryElement.children().first().append(toggleElement);

                // If the current node is active, we manually trigger the collapse and the recursion will take care of next loop
                if (node.active) {
                    toggleElement.trigger("click");
                }
            }
            children.isSuccessful = true;
        }
        catch (e) {
            children.isSuccessful = false;
            console.error(e);
        }
        finally {
            children.isLoading = false;
        }
    }
}
